import React from 'react';
import Styles from './FeaturedBlogPost.module.less';
import { classes } from '../../../lib';
import { Button } from '../../Button';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { generatePath } from 'react-router-dom';
import routes from '../../../pages/landingPage/routes';

export type FeaturedBlogPostProps = {
    title: string;
    children: React.ReactNode;
    image: React.ReactNode;
    url: string;
};

export const FeaturedBlogPost = ({
    title,
    children,
    image,
    url,
}: FeaturedBlogPostProps): JSX.Element => {
    const isExternal = url.startsWith('http');
    const postUrl = isExternal
        ? url
        : generatePath(routes.blog.post.path, {
              postSlug: url,
          });
    return (
        <div
            className={classes(
                'td-horizontal m-vertical center-top td-g32 m-g8',
                Styles.container
            )}>
            <div
                className={classes(
                    'vertical stretch-top g16 flex td-hidden',
                    Styles.image
                )}>
                {image}
            </div>
            <div
                className={classes(
                    'vertical left-middle g32 py16',
                    Styles.content
                )}>
                <a href={postUrl}>
                    <h1>{title}</h1>
                </a>
                <p className="medium-alude">{children}</p>
                <Button
                    className="semilarge-semibold-alude"
                    type="link"
                    size="small"
                    href={postUrl}>
                    Leia mais <FontAwesomeIcon icon={faArrowRight} />
                </Button>
            </div>
            <div
                className={classes(
                    'vertical stretch-top g16 flex m-hidden',
                    Styles.image
                )}>
                <a href={postUrl}>{image}</a>
            </div>
        </div>
    );
};
